module.exports = __webpack_public_path__ + "img/centerCensus2.cfb3f39f.png";